import { SupportTicketStatus } from "./types";

// Лимиты бэка на длину полей тикета и сообщения.
export const TICKET_SUBJECT_MAX_LENGTH = 255;
export const TICKET_BODY_MAX_LENGTH = 10_000;

export const TICKET_STATUS_LABELS: Record<SupportTicketStatus, string> = {
  [SupportTicketStatus.NEW]: "New",
  [SupportTicketStatus.IN_PROGRESS]: "In progress",
  [SupportTicketStatus.ANSWERED]: "Answered",
  [SupportTicketStatus.CLOSED]: "Closed",
};
